module.exports = __webpack_public_path__ + "89e3a9559d648d40e05bcedc24dacb7c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/ribbons/numbers/3-plus.png
// module id = 3619
// module chunks = 0